import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect x={0.5} y={0.5} width={39} height={39} rx={19.5} fill="#fff" />
        <rect x={0.5} y={0.5} width={39} height={39} rx={19.5} stroke={theme["#B4E3E1"]} />
        <path
            d="M25.45 13.476l-4.583-1.717c-.475-.175-1.25-.175-1.725 0l-4.583 1.717c-.883.333-1.6 1.366-1.6 2.308v6.75c0 .675.442 1.567.983 1.967l4.584 3.425c.808.608 2.133.608 2.941 0l4.584-3.425c.541-.409.983-1.292.983-1.967v-6.75c.008-.942-.708-1.975-1.583-2.308zm-4.824 7.25v2.192a.63.63 0 01-.625.625.63.63 0 01-.625-.625v-2.192a2.081 2.081 0 01-1.459-1.975 2.084 2.084 0 014.167 0c0 .933-.617 1.708-1.458 1.975z"
            fill={theme["#0EA59D"]}
        />
        </svg>
    )
}
  
  export default SvgComponent